module.exports = __webpack_public_path__ + "img/pudding.be5030ca.webp";